import Marionette from 'backbone.marionette';
import Navigator from 'app';
import filtersCompositeviewTmpl from '../templates/members_browse_filters_compositeview.tpl';
import CountyItemview from './members_browse_filters_county_itemview';
export default Marionette.CompositeView.extend({
  template: filtersCompositeviewTmpl,
  childView: CountyItemview,
  childViewContainer: "select#members-county-select",
  events: {
    "click .btn-filter": "filterMembers",
    "change select#members-county-select": "selectCounty",
    "keyup #members-name-input": "searchByName"
  },
  // this fires only for filter *button* interactions, not name search or county select
  filterMembers: function filterMembers(e) {
    e.preventDefault();
    //apply selected (btn-filter-default) style to clicked button in a group
    $(e.currentTarget).siblings().removeClass("btn-filter-default");
    $(e.currentTarget).addClass("btn-filter-default");

    // search criterion key is in the id of the div containing a group of buttons
    var key = $(e.currentTarget).parent().attr("id").match(/filter-(.*)$/)[1];
    // search criterion value is in the button id
    var val = $(e.currentTarget).attr("id").match(/filter-(.*)$/)[1];
    var criterion = {};
    criterion[key] = val;
    Navigator.vent.trigger("member:home:show", criterion);
    const filter = {
      filter_type: key,
      value: val
    };
    // for analytics
    Navigator.vent.trigger("members:filter:applied", filter);
  },
  selectCounty: function (e) {
    var county = e.target.value;
    console.log("selectCounty: ", county);
    Navigator.vent.trigger("members:by:county", county);
    const filter = {
      filter_type: "county",
      value: county
    };
    // for analytics
    Navigator.vent.trigger("members:filter:applied", filter);
  },
  // we want this to feel like it's filtering as you type but it triggers a request (I'm not sure why we can't just filter the collection?) so we don't want to run more than necessary
  debouncedSearchByNameEval: _.debounce(function (inputStr) {
    console.log("EMD debouncedSearchByNameEval inputStr: ", inputStr);
    Navigator.vent.trigger("members:by:name", inputStr);
  }, 700),
  // we want to track use of the filter so we don't want to fire this until the user is likely done with the query
  debouncedAnalyticsSearchByNameTrigger: _.debounce(function (inputStr) {
    const filter = {
      filter_type: "name",
      value: inputStr
    };
    Navigator.vent.trigger("members:filter:applied", filter);
  }, 2500),
  searchByName: function (e) {
    let inputStr = e.target.value;
    this.debouncedSearchByNameEval(inputStr);
    this.debouncedAnalyticsSearchByNameTrigger(inputStr);
  },
  /** runs when a filter button is selected to change which one displays as active (only one criterion can be active at once i.e. party or chamber) */
  onSetFilterCriterion: function onSetFilterCriterion(criterion) {
    // apply 'selected' style to appropriate filter buttons based on
    // the current filter without necessarily clicking the filter buttons
    $(".filter").removeClass("btn-filter-default");
    if (!criterion.party) {
      $("#filter-party").children("#filter-all-parties").addClass("btn-filter-default");
    } else {
      $("#filter-" + criterion.party).addClass("btn-filter-default");
    }
    if (!criterion.district_type) {
      $("#filter-district_type").children("#filter-all-districtTypes").addClass("btn-filter-default");
    } else {
      $("#filter-" + criterion.district_type).addClass("btn-filter-default");
    }
  },
  onShow: function onMemberBrowseFiltersShow() {
    // $(document).tooltip({
    //   items: "div.member",
    //   predelay: 0,
    //   cancelDefault: true,
    //   position: {
    //     my: "center bottom",
    //     at: "center top",
    //     collision: "flipfit"
    //   }
    // });
  }
});